var Backbone, SortToggleView, ref,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = (ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? ref : require('backbone');

SortToggleView = (function(superClass) {
  extend(SortToggleView, superClass);

  function SortToggleView() {
    return SortToggleView.__super__.constructor.apply(this, arguments);
  }

  SortToggleView.prototype.events = {
    'change': '_onChange'
  };

  SortToggleView.prototype._onChange = function() {
    return this.trigger('change:value', {
      sort: this.$el.val()
    });
  };

  return SortToggleView;

})(Backbone.View);

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = SortToggleView;
} else {
  Modules.SortToggle.Views.SortToggle = SortToggleView;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9ncnBuLXNvcnRzL2Zyb250ZW5kL3ZpZXdzL3NvcnRfdG9nZ2xlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvZ3Jwbi1zb3J0cy9mcm9udGVuZC92aWV3cy9zb3J0X3RvZ2dsZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsSUFBQSw2QkFBQTtFQUFBOzs7QUFBQSxRQUFBLHVHQUE4QixPQUFBLENBQVEsVUFBUjs7QUFFeEI7Ozs7Ozs7MkJBQ0osTUFBQSxHQUNFO0lBQUEsUUFBQSxFQUFVLFdBQVY7OzsyQkFFRixTQUFBLEdBQVcsU0FBQTtXQUNULElBQUMsQ0FBQSxPQUFELENBQVMsY0FBVCxFQUF5QjtNQUFBLElBQUEsRUFBTSxJQUFDLENBQUEsR0FBRyxDQUFDLEdBQUwsQ0FBQSxDQUFOO0tBQXpCO0VBRFM7Ozs7R0FKZ0IsUUFBUSxDQUFDOztBQU90Qyx1REFBRyxNQUFNLENBQUUsZ0JBQVg7RUFDRSxNQUFNLENBQUMsT0FBUCxHQUFpQixlQURuQjtDQUFBLE1BQUE7RUFHRSxPQUFPLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxVQUF6QixHQUFzQyxlQUh4QyJ9
